<mat-card *ngIf="editClientSociData" style="height:100%">
 <form #loginForm="ngForm">
    <mat-toolbar style="width:100%">
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-right:0" (click)="close()" matTooltip="{{ 'common.tancar' | translate }}" attr.aria-label="{{ 'common.tancar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-right: 0" (click)="desar()" matTooltip="{{ 'clientsSocis.desarToolTip' | translate }}" attr.aria-label="{{ 'clientsSocis.desarToolTip' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress"></mat-progress-bar>
    <mat-card-content style="float:left;clear:both;padding: 24px;width:100%">
      <h2 mat-line style="width:70%;color: black">{{ 'clientsSocis.titol' | translate }}</h2>
      <div style="float:left;clear:none;margin-top:5px;width:90%">
      <mat-form-field style="width: 65%;float:left;clear:none">
       <input matInput placeholder="{{ 'clientsSocis.cmpnom' | translate }}" name="nom" [(ngModel)]="editClientSociData.nom" ngDefaultControl />
      </mat-form-field>
      <mat-select style="width:25%;float:left;clear:none;padding-left:1%;padding-top:10px" [(ngModel)]="editClientSociData.tipus" [ngModelOptions]="{standalone: true}" placeholder="{{ 'clientsSocis.cmptipus' | translate }}">
        <mat-option *ngFor="let tipus of possibleTipus" [value]="tipus" [selected]="tipus === editClientSociData.tipus">{{tipus}}</mat-option>
      </mat-select>
      <mat-form-field style="width: 65%;float:left;clear:left">
       <input matInput placeholder="{{ 'clientsSocis.cmpadreca' | translate }}" name="adreca"
        [(ngModel)]="editClientSociData.adreca" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 12%;float:left;clear:none;padding-left:1%">
       <input matInput placeholder="{{ 'clientsSocis.cmplocalitzacio' | translate }}" name="localitzacio"
        [(ngModel)]="editClientSociData.localitzacio" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width:11%;float:left;clear:none;padding-left:1%">
        <mat-select style="width:100%;height:19px;border: 0px" [(ngModel)]="editClientSociData.country" [ngModelOptions]="{standalone: true}" placeholder="{{ 'clientsSocis.cmppais' | translate }}">
            <mat-option *ngFor="let country of possiblePaisos" [value]="country" [selected]="country === editClientSociData.country">{{country}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 15%;float:left;clear:left">
       <input matInput placeholder="{{ 'clientsSocis.cmpcif' | translate }}" name="cif"
        [(ngModel)]="editClientSociData.cif" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 15%;float:left;clear:none;padding-left:1%">
       <input matInput placeholder="{{ 'clientsSocis.cmptelefon' | translate }}" name="telefon"
        [(ngModel)]="editClientSociData.telefon" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 30%;float:left;clear:none;padding-left:1%">
       <input matInput placeholder="{{ 'clientsSocis.cmpmail' | translate }}" name="mail"
        [(ngModel)]="editClientSociData.mail" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 65%;float:left;clear:left">
       <input matInput placeholder="{{ 'clientsSocis.cmpweb' | translate }}" name="web"
        [(ngModel)]="editClientSociData.web" ngDefaultControl/>
      </mat-form-field>
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%">
        <mat-form-field style="width: 90%">
          <textarea matInput placeholder="{{ 'clientsSocis.cmpnomlegal' | translate }}" name="descripcio" rows="3" [(ngModel)]="editClientSociData.descripcio"  style="width: 100%">
          </textarea>
        </mat-form-field> 
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%">
        <mat-form-field style="width: 100%">
          <textarea matInput placeholder="{{ 'clientsSocis.cmpcomentaris' | translate }}" name="comentari" rows="3" [(ngModel)]="editClientSociData.comentari"  style="width: 100%">
          </textarea>
        </mat-form-field> 
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%">
        <mat-checkbox style="margin-right: 1em;"  name="client" [(ngModel)]="editClientSociData.client">{{ 'clientsSocis.chkclient' | translate }}</mat-checkbox>
        <mat-checkbox style="margin-right: 1em;"  name="soci" [(ngModel)]="editClientSociData.soci">{{ 'clientsSocis.chksoci' | translate }}</mat-checkbox>
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%;padding-left:20px" *ngIf="error !== ''">
        <span style="color:red;font-weight: bold">{{error}}</span>
      </div>
    </mat-card-content>
  </form>
</mat-card>
